import { render, staticRenderFns } from "./OutAmount.vue?vue&type=template&id=c1372676&scoped=true"
import script from "./OutAmount.vue?vue&type=script&lang=js"
export * from "./OutAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1372676",
  null
  
)

export default component.exports